import { Check } from 'lucide-react';

interface StepIndicatorProps {
  step: number;
  currentStep: number;
  className?: string;
}

export function StepIndicator({ step, currentStep, className }: StepIndicatorProps) {
  const isActive = step === currentStep;
  const isCompleted = step < currentStep;

  return (
    <div className={`flex items-center justify-center z-10 ${className || ''}`}>
      <div
        className={`flex items-center justify-center w-10 h-10 rounded-full transition-colors ${
          isActive ? "bg-primary-600 text-white border-2 border-primary-600" :
          isCompleted ? "bg-primary-400 text-white" :
          "bg-white text-gray-500 border-2 border-gray-300"
        }`}
      >
        {isCompleted ? (
          <Check className="w-5 h-5" />
        ) : (
          <span className="font-medium">{step}</span>
        )}
      </div>
    </div>
  );
}